import { render, staticRenderFns } from "./FeaturedArticles.vue?vue&type=template&id=31ea572c&"
import script from "./FeaturedArticles.vue?vue&type=script&lang=js&"
export * from "./FeaturedArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports